/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DAS HINTERGRUND-MUSTER DES BANDES — fuenf Muster aus dem Entwurf des
 * Betreibers vom 24.09.2026. Es liegt als Schicht ueber dem Farbverlauf
 * und ist immer nur eine Andeutung in Weiss; die Farben kommen aus dem
 * Verlauf, nicht aus dem Muster.
 * 
 *   ORB         — ein Lichtkreis oben rechts (das bisherige Aussehen).
 *   PUNKTE      — feines Punkteraster, nach links ausblendend.
 *   WELLE       — zwei Wellen ueber die ganze Breite, unten anliegend.
 *   LICHTSCHEIN — weicher Lichtschein von oben rechts, diagonal.
 *   STREIFEN    — feine diagonale Streifen, nach links ausblendend.
 *   VERLAUF     — KEINE Zeichnung in Weiss, sondern der Verlauf selbst:
 *                 von rechts nach links, nur aus den beiden gewaehlten
 *                 Farben. Betreiber 24.09.2026: „Bitte bei Muster noch
 *                 den Gradienteffekt von rechts nach links nur auf Basis
 *                 der beiden gewaehlten Farben … sind beide Farbpicker
 *                 gleich ist auch der Hintergrund einfarbig."
 * 
 * Ohne Angabe gilt PUNKTE — die Vorgabe fuer die Vorlagen („Bitte in die
 * Templates die Variante 2 mit Punkten und dem Mustertext einbauen.").
 * @export
 */
export const DatabaseNewsletterMuster = {
    Orb: 'ORB',
    Punkte: 'PUNKTE',
    Welle: 'WELLE',
    Lichtschein: 'LICHTSCHEIN',
    Streifen: 'STREIFEN',
    Verlauf: 'VERLAUF'
} as const;
export type DatabaseNewsletterMuster = typeof DatabaseNewsletterMuster[keyof typeof DatabaseNewsletterMuster];


export function DatabaseNewsletterMusterFromJSON(json: any): DatabaseNewsletterMuster {
    return DatabaseNewsletterMusterFromJSONTyped(json, false);
}

export function DatabaseNewsletterMusterFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseNewsletterMuster {
    return json as DatabaseNewsletterMuster;
}

export function DatabaseNewsletterMusterToJSON(value?: DatabaseNewsletterMuster | null): any {
    return value as any;
}

